<template>
  <v-list>
    <template v-for="(produto, index) in cotacao.produtos">
      <v-list-item :key="produto.id">
        <v-list-item-content>
          <v-list-item-title>
            <px-situacao-cotacao-icon :situacao="produto.situacao"/>
            <px-span-tooltip v-if="produto.produto.codigo"
                             top
                             :text="`${produto.produto.codigo} - `"
                             tooltip="Código interno"/>
            <px-span-tooltip top
                             :text="labelDescricao(produto.produto)"
                             :tooltip="produto.produto.descricao"/>
          </v-list-item-title>
          <v-list-item-subtitle class="ml-5">
            <px-span-tooltip v-if="codigoFornecedor(produto.produto)"
                             top
                             :text="codigoFornecedor(produto.produto)"
                             tooltip="Código de referência do fornecedor"/>
            {{ produto.quantidade | number(getCurrencyFormat(produto.produto.casasDecimais)) }}
            {{produto.unidadeMedida.descricao}}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <px-historico-preco-produto :produto="produto.produto"
                                      :unidade-medida="produto.unidadeMedida"/>
        </v-list-item-action>
        <v-list-item-action>
          <px-detalhes-produto
            :produto="produto"
            show-projeto
            show-centro-custo
            show-obs-externa
            show-obs-interna/>
        </v-list-item-action>
        <v-list-item-action>
          <px-anexo read-only
                    v-model="produto.arquivos"
                    download-base-path="files/download-comprador"/>
        </v-list-item-action>
        <v-list-item-action>
          <px-cotacao-produto-menu v-if="hasModuleGerencia"
                                   :cotacao="cotacao"
                                   :cotacao-produto="produto"
                                   @update="emitUpdate"/>
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="index !== (cotacao.produtos.length - 1)"
        :key="`v-div${produto.id}`"/>
    </template>
  </v-list>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { CasaDecimalUtils } from 'px-components';
import CotacaoProdutoMenu from './CotacaoProdutoMenu.vue';

export default {
  props: {
    cotacao: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    labelDescricao() {
      return produto => Vue.filter('truncate')(produto.descricao, 25);
    },
    codigoFornecedor() {
      return item => item.codigoFornecedor;
    },
  },
  components: {
    pxCotacaoProdutoMenu: CotacaoProdutoMenu,
  },
};
</script>
